export default "__VITE_PUBLIC_ASSET__02eb4897__"